export default "__VITE_ASSET__CF9L9zT2__"